class ODataQueryBuilder {
  constructor(baseUrl, entitySet, headers) {
    this.baseUrl = baseUrl;
    this.entitySet = entitySet;
    this.headers = headers;
  }

  getMetadataUrl() {
    const url = `${this.baseUrl}/${this.entitySet}/metadata`;

    return url;
  }

  buildUrl(query) {
    let url = `${this.baseUrl}/${this.entitySet}`;

    const {
      itemsPerPage = 100, page = 0, sortDesc = 0, sortBy = [], filter = null, search = '', expand,
    } = query;
    if (itemsPerPage) {
      url += `?$top=${itemsPerPage}`;
    }
    if (page > 1) {
      url += `&$skip=${itemsPerPage * (page - 1)}`;
    }

    if (filter?.length > 1) {
      url += `&$filter=${filter}`;
    }

    if (expand?.length > 1) {
      url += `&$expand=${expand}`;
    }

    if (sortBy.length > 0) {
      // const orderBy = orderby
      //   .map((item) => (item.direction ? `${item.field} ${item.direction}` : item.field))
      //   .join(',');

      url += `&$orderby=${sortBy.join(',')} ${sortDesc ? 'desc' : 'asc'}`;
    }

    if (search?.length > 1) {
      const searchFields = this.headers
        .filter((header) => header.searchable)
        .map((header) => `contains(${header.value}, '${search}')`);
      url += `&$filter=${searchFields.join(' OR ')}`;
    }

    url += '&$count=true';

    return url;
  }
}

export default ODataQueryBuilder;
